export default __webpack_public_path__ + "app/assets/images/job_offer/thumbnail-cg-02a09fe50ee77b52a0c2c0b6641a8235.jpg";